import DatetimeUtils from "../../../utils/datetime-utils";

export default class RateExperienceManager {


    static markNoRateNeeded() {
        gd.user.clientData.rateExperience = false;
        gd.user.saveClientData();
    };

    static needRate() {

        if (!gd.user.clientData.rateExperience) return false;

        const momentToRate = DatetimeUtils.datetimeToMoment(gd.user.clientData.rateExperience);

        if (momentToRate && moment().isAfter(momentToRate)) {
            return true;
        }

        return false;
    }

}